import TextField from "./index";
import styles from "./styles.module.css";

export default function PasswordField({ ...props }) {
  return <TextField type="password" placeholder="* * * * * * * *" {...props} />
}
